

// message snack
// export const GET_TRANSACTION_MESSAGE = 'GET_TRANSACTION_MESSAGE'

export const GET_TRANSACTION_MESSAGE =  'GET_TRANSACTION_MESSAGE'

export const FETCH_USER = 'FETCH_USER'
export const UPDATE_USER = 'UPDATE_USER'
export const INSERT_USER = 'INSERT_USER'
export const CREATE_USER = 'CREATE_USER'
export const DELETE_USER = 'DELETE_USER'
export const CHANGE_STATE_USER = 'CHANGE_STATE_USER'
export const LOGIN_USER = 'LOGIN_USER'
export const FIND_USER = 'FIND_USER'

// authentication
export const REGISTER_REQUEST = 'REGISTER_REQUEST'
export const REGISTER_SUCCESS = 'REGISTER_SUCCESS'
export const REGISTER_FAILURE = 'REGISTER_FAILURE'
export const LOGIN_REQUEST = 'LOGIN_REQUEST'
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS'
export const LOGIN_FAILURE = 'LOGIN_FAILURE'
export const LOGOUT = 'LOGOUT'
export const RESET_STORE = 'RESET_STORE'
export const GETALL_REQUEST = 'GETALL_REQUEST'
export const GETALL_SUCCESS = 'GETALL_SUCCESS'
export const GETALL_FAILURE = 'GETALL_FAILURE'
export const DELETE_REQUEST = 'DELETE_REQUEST'
export const DELETE_SUCCESS = 'DELETE_SUCCESS'
export const DELETE_FAILURE = 'DELETE_FAILURE'
export const CHANGE_PASS = 'CHANGE_PASS'
export const RESPONSE_QUESTIONS = 'RESPONSE_QUESTIONS'

// customers
export const FETCH_CUSTOMER = 'FETCH_CUSTOMER'
export const UPDATE_CUSTOMER = 'UPDATE_CUSTOMER'
export const INSERT_CUSTOMER = 'INSERT_CUSTOMER'
export const DELETE_CUSTOMER = 'DELETE_CUSTOMER'


// user-urlTransactions
export const SEND_TRANSACTIONS_PAYMENT = 'SEND_TRANSACTIONS_PAYMENT'
export const GET_TRANSACTIONS_QR_PAYMENT = 'GET_TRANSACTIONS_QR_PAYMENT'
export const GET_TRANSACTIONS_PAYMENT_TRAY = 'GET_TRANSACTIONS_PAYMENT_TRAY'
export const UPDATE_TRANSACTIONS_PAYMENT_TRAY = 'UPDATE_TRANSACTIONS_PAYMENT_TRAY'
export const GET_TRANSACTIONS_CHARGES_TRAY = 'GET_TRANSACTIONS_CHARGES_TRAY'
export const UPDATE_TRANSACTIONS_CHARGES_TRAY = 'UPDATE_TRANSACTIONS_CHARGES_TRAY'
export const GET_TRANSACTIONS_OTP_PAYMENT = 'GET_TRANSACTIONS_OTP_PAYMENT'
export const GET_TRANSACTIONS_COMPARE_OTP_PAYMENT = 'GET_TRANSACTIONS_COMPARE_OTP_PAYMENT'


//device of  log customer
export const FETCH_DEVICE = 'FETCH_DEVICE'

// balances
export  const GET_BALANCE = 'GET_BALANCE'
export  const UPDATE_BALANCE = 'UPDATE_BALANCE'

//chequera
export const GENERATE_CHECKBOOK = 'GENERATE_CHECKBOOK'
export const GET_CHECKBOOK = 'GET_CHECKBOOK'
export const GET_CHECKBOOK_EMITED = 'GET_CHECKBOOK_EMITED'
export const GET_CHECKBOOK_CHARGE = 'GET_CHECKBOOK_CHARGE'
export const GET_CHECKBOOK_ENDORSMENT = 'GET_CHECKBOOK_ENDORSMENT'

//codes para movimientos
export const GET_CODES = 'GET_CODES'
export const GET_CODES_CORE = 'GET_CODES_CORE'
export const CREATE_CODES = 'CREATE_CODES'
export const CHANGE_CODES = 'CHANGE_CODES'
export const FIND_CODES_LOGIN_BY_USER = 'FIND_CODES_LOGIN_BY_USER'

// pago de servicios taxes
export const PAY_SERVICE = 'PAY_SERVICE'

// servicios
export const GET_SERVICE = 'GET_SERVICE'

// tipos de servicios /taxes
export const GET_TYPE_TAXES = 'GET_TYPE_TAXES'
export const GET_OTP_TAXES = 'GET_OTP_TAXES'

// manejo de paginas
export const ACTUAL_PAGE = 'ACTUAL_PAGE'

//codes real-time
export const UPDATE_CODES = 'UPDATE_CODES'

//Beneficiarios
export const ADD_BENEFICIARY = 'ADD_BENEFICIARY'
export const GET_BENEFICIARIES = 'GET_BENEFICIARIES'
export const GET_BENEFICIARIES_CORE = 'GET_BENEFICIARIES_CORE'
export const DELETE_BENEFICIARY = 'DELETE_BENEFICIARY'
export const UPDATE_BENEFICIARY = 'UPDATE_BENEFICIARY'

// transferencias internas
export const TRANSFER_REQUEST = 'TRANSFER_REQUEST'

// notificaciones
export const NEW_NOTIFICATION = 'NEW_NOTIFICATION'
export const UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATION'

//verificates
export const NEW_VERIFICATE = 'NEW_VERIFICATE'
export const UPDATE_VERIFICATE = 'UPDATE_VERIFICATE'
export const FIND_VERIFICATE = 'FIND_VERIFICATE'

// credits core
export const FIND_CREDITS = 'FIND_CREDITS'
export const GET_ADITIONAL_CREDITS = 'GET_ADITIONAL_CREDITS'
export const GET_INITIAL_CREDITS = 'GET_INITIAL_CREDITS'
export const GET_TYPE_CREDITS = 'GET_TYPE_CREDITS'


// transfers-core
export const CREATE_TRANSFER_CORE = 'CREATE_TRANSFER_CORE'
export const CREATE_EXTERNAL_TRANSFER_CORE = 'CREATE_EXTERNAL_TRANSFER_CORE'
export const FIND_TRANSFER_CORE = 'FIND_TRANSFER_CORE'

// entities - core
export const GET_ENTITIES_CORE = 'GET_ENTITIES_CORE'

//institutions -core 
export const GET_INSTITUTION_CORE = 'GET_INSTITUTION_CORE'

// electric companies - core
export const GET_ELECTRIC_COMPANIES_CORE = 'GET_ELECTRIC_COMPANIES_CORE'

// meters - core
export const GET_METER_CORE = 'GET_METER_CORE'
export const CREATE_METER_CORE = 'CREATE_METER_CORE'
export const GET_METERS_LIST = 'GET_METERS_LIST'
export const PROCESS_METER_PAYMENT_CORE = 'PROCESS_METER_PAYMENT_CORE'
export const CREATE_PROCESS_METER_CODE = 'CREATE_PROCESS_METER_CODE'

// taxes - core
export const GET_PERIODS_CORE = 'GET_PERIODS_CORE'
export const GET_LEVELS_CORE = 'GET_LEVELS_CORE'


// agreements - convenios
export const GET_AGREEMENTS = 'GET_AGREEMENTS'


// Loading page
export const LOADING_PAGE = 'LOADING_PAGE'



// Plazo fijo
export const GET_ALL_DEPOSITS = 'GET_ALL_DEPOSITS'
export const GET_ADITIONAL_DEPOSIT = 'GET_ADITIONAL_DEPOSIT'
export const GET_DEPOSIT_MOVEMENTS = 'GET_DEPOSIT_MOVEMENTS'

//parameters
export const FIND_PARAMETERS = 'FIND_PARAMETERS'
export const UPDATE_PARAMETERS = 'UPDATE_PARAMETERS'

//Voucher
export const SEND_EMAIL_WITH_VOUCHER = 'SEND_EMAIL_WITH_VOUCHER'

//Send Email
export const SEND_EMAIL = 'SEND_EMAIL'


//QUOTAS
export const GET_QUOTAS = 'GET_QUOTAS'
export const UPDATE_QUOTAS = 'UPDATE_QUOTAS'
export const UPDATE_QUOTAS_REDUCE = 'UPDATE_QUOTAS_REDUCE'


//SIIM
export const GET_SIIM = 'GET_SIIM'

//QUESTIONS
export const GET_QUESTIONS = 'GET_QUESTIONS'

//USERS QUESTIONS
export const GET_QUESTIONS_BY_USER = 'GET_QUESTIONS_BY_USER'
export const CREATE_QUESTIONS_BY_USER = 'CREATE_QUESTIONS_BY_USER'



// DEVICE REGISTERED
export const REGISTER_DEVICE = 'REGISTER_DEVICE'
export const UPDATE_DEVICE_IP = 'UPDATE_DEVICE_IP'

// SERVICES AGREEMENTS
export const GET_AGREEMENT_TYPES = 'GET_AGREEMENT_TYPES'
export const UPDATE_AGREEMENT_TYPES = 'UPDATE_AGREEMENT_TYPES'

// SWITCH SERVICES

export const GET_AGREEMENTS_BY_INSTITUTION = "GET_AGREEMENTS_BY_INSTITUTION"

// RECAUDACIONES OTROS SERVICIOS
export const GET_OTHER_SERVICES = "GET_OTHER_SERVICES"

export const GET_CERTIFICATES = 'GET_CERTIFICATES'

export const GET_FOUNDATIONS = 'GET_FOUNDATIONS'

export const SETTING_IDE = '3'

// NOMINA
export const GET_PAYROLL = 'GET_PAYROLL'
export const GET_COMPANY = 'GET_COMPANY'

// ESTADOS
export const GET_STATES = 'GET_STATES'

// PERMISOS
export const GET_USER_PERMISSIONS = 'GET_USER_PERMISSIONS'

//MENU
export const GET_MENU = 'GET_MENU'
export const UPDATE_MENU = 'UPDATE_GET_MENU'
export const UPDATE_MENU_AGREEMENTS = 'UPDATE_MENU_AGREEMENTS'

export const CREATE_AUTHORIZED_INTERNAL_TRANSFER = 'CREATE_AUTHORIZED_INTERNAL_TRANSFER'
export const CREATE_AUTHORIZED_EXTERNAL_TRANSFER = 'CREATE_AUTHORIZED_EXTERNAL_TRANSFER'
export const CREATE_AUTHORIZED_SWITCH_PAYMENT = 'CREATE_AUTHORIZED_SWITCH_PAYMENT'